module.exports = __webpack_public_path__ + "static/media/software.cf77d20f.png";